/**
 * Finds the index of an option in the member options array
 * @param {Object} option - The option to find
 * @param {Array} memberOptions - Array of all member options
 * @returns {number} - The index of the option, or -1 if not found
 */
export const getOptionIndex = (option, memberOptions) => {
  return memberOptions.findIndex(opt => 
    (opt.id && option.id && opt.id === option.id) ||
    (opt.username && option.username && opt.username === option.username) ||
    (opt.label === option.label)
  );
};

